/**
 * @license
 * Copyright (c) %FIRST_YEAR% %CURRENT_YEAR%, Oracle and/or its affiliates. All rights reserved.
 * https://www.oracle.com/contracts/docs/cloud_csa_online_v062223_us_eng.pdf?download=false&er=221886
 * @ignore
 */
// DO NOT MODIFY THIS FILE MANUALLY!
// This file is automatically generated based on the corresponding SVG image in
// the packages/oraclejet-preact/resources/icons folder.
import { ComponentProps } from 'preact';
import { Icon } from '../../UNSAFE_Icon';
type Props = Omit<ComponentProps<typeof Icon>, 'viewBox' | 'children'>;
const SvgAuditTrail = (props: Props) => (
  <Icon viewBox="0 0 24 24" {...props}>
    <g fill="none">
      <path
        d="M2 2h8v8H2zm2 2v4h4V4zm11.414 3 1.293 1.293-1.414 1.414L11.586 6l3.707-3.707 1.414 1.414L15.414 5H22v7h-2V7zM7 17v-5H5v10h2v-3h5v-2zm7-3h8v8h-8zm2 2v4h4v-4z"
        fill="currentcolor"
      />
    </g>
  </Icon>
);
export { SvgAuditTrail as AuditTrail };
